import { useEffect } from 'react';
import { usePrevious } from '../../common/hooks/usePrevious';
import { getStandaloneConnectionId } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { Metrics, OPEN_REMOTE } from 'calling-remote-common/utils/Metrics';
export const useShowAlertOnCallTabClose = openRemote => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const standaloneConnectionId = getStandaloneConnectionId(widgetDetails);
  const prevConnectionId = usePrevious(standaloneConnectionId);
  useEffect(() => {
    if (standaloneConnectionId === undefined && prevConnectionId) {
      openRemote();
      Metrics.counter(OPEN_REMOTE, {
        source: 'call-tab-closed'
      }).increment();
    }
  }, [standaloneConnectionId, prevConnectionId, openRemote]);
};